import React, { useState, useEffect } from 'react';
import db from '../firebase/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import styles from '../styles/DecisionTool.styles';

const Submission = ({ roundNumber, teamId }) => {
    console.log('in submission..teamid', { teamId }, ' round number: ', { roundNumber });

    // Parse the fullTeamId into teamId and submissionType
    const teamIdParts = teamId.split("_");
    const submissionType = teamIdParts.pop();
    const teamIdParsed = teamIdParts.join("_");

    console.log(submissionType)
    console.log(teamIdParsed)

    const [submissionData, setSubmissionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const attributeOrder = [
        "Speed", "Comfort", "BatteryRange", "AllTerrain",
        "Security", "SmartFeatures", "Storage", "Safety"
    ];

    useEffect(() => {
        const fetchSubmissionData = async () => {
            setLoading(true);
            try {
                const teamDocRef = doc(db, submissionType, teamIdParsed);
                const teamSnap = await getDoc(teamDocRef);

                if (teamSnap.exists()) {
                    const teamData = teamSnap.data();
                    const roundData = teamData.rounds?.find((round) => round.roundNumber === roundNumber);

                    if (roundData) {
                        setSubmissionData(roundData);
                    } else {
                        setError("No data found for the specified round.");
                    }
                } else {
                    setError("Team data not found.");
                }
            } catch (err) {
                setError("Failed to load submission data.");
            } finally {
                setLoading(false);
            }
        };

        fetchSubmissionData();
    }, [roundNumber, submissionType, teamId, teamIdParsed]);

    if (loading) return <p>Loading submission details...</p>;
    if (error) return <p>{error}</p>;

    console.log('submitted data:', submissionData);

    const upgradedBike = submissionData?.manufacturing?.upgraded_bike || {};
    const rndUpgrades = submissionData?.rnd?.upgrades || {};

    // Extract segments and ad budgets from the advertising data
    const selectedSegments = submissionData?.advertising.segments || [];
    const performanceAds = submissionData?.advertising.performance_ads || {};
    const brandAds = submissionData?.advertising.brand_ads || {};
    const profitMargin = submissionData?.profit_margin || {};
    return (
        <div style={{ textAlign: 'left', padding: '50px' }}>
            <div style={{ textAlign: 'center' }}>
                <h2>Final Manufactured Bike</h2>
            </div>

            <p>This table displays the bike attributes from round {roundNumber} after tradeoffs and R&D upgrades.</p>

            <table className={styles.tradeoffTable}>
                <thead>
                    <tr>
                        <styles.th>Attribute</styles.th>
                        {attributeOrder.map((attribute) => (
                            <styles.th key={attribute}>{attribute}</styles.th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <styles.td>Level</styles.td>
                        {attributeOrder.map((attribute) => (
                            <styles.td key={attribute}>{upgradedBike[attribute] || "-"}</styles.td>
                        ))}
                    </tr>
                </tbody>
            </table>

            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h2>R&D Upgrades: Round {roundNumber}</h2>
            </div>

            <p>These values have been included in the bike manufactured above.</p>

            <table className={styles.tradeoffTable}>
                <thead>
                    <tr>
                        <styles.th>Attribute</styles.th>
                        {attributeOrder.map((attribute) => (
                            <styles.th key={attribute}>{attribute}</styles.th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <styles.td>Level</styles.td>
                        {attributeOrder.map((attribute) => (
                            <styles.td key={attribute}>{rndUpgrades[attribute] || "-"}</styles.td>
                        ))}
                    </tr>
                </tbody>
            </table>

            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h2>Final Ad Spend: Round {roundNumber}</h2>
            </div>

            <div>
                <p><strong>Segments Selected:</strong> {selectedSegments.join(', ')}</p>

                <table className={styles.tradeoffTable}>
                    <thead>
                        <tr>
                            <styles.th>Attribute</styles.th>
                            <styles.th>Broad/General</styles.th>
                            {attributeOrder.map((attribute) => (
                                <styles.th key={attribute}>{attribute}</styles.th>
                            ))}

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <styles.td>Performance</styles.td>
                            <styles.td>{performanceAds['Broad'] || "-"}</styles.td>
                            {attributeOrder.map((attribute) => (
                                <styles.td key={attribute}>{performanceAds[attribute] || "-"}</styles.td>
                            ))}

                        </tr>
                        <tr>
                            <styles.td>Brand</styles.td>
                            <styles.td>{brandAds['Broad'] || "-"}</styles.td>
                            {attributeOrder.map((attribute) => (
                                <styles.td key={attribute}>{brandAds[attribute] || "-"}</styles.td>
                            ))}

                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <h2>Profit Margin: Round {roundNumber}</h2>
                </div>
                <div>
                    <table className={styles.tradeoffTable}>
                        <tbody>
                            <tr>
                                <styles.att2><strong>Profit Margin Selection</strong></styles.att2>
                                <styles.td>{profitMargin.profit_margin_selection || "-"}</styles.td>
                            </tr>
                            <tr>
                                <styles.att2><strong>Profit Margin Percent (%)</strong></styles.att2>
                                <styles.td>{profitMargin.profit_margin_percent || "-"}</styles.td>
                            </tr>
                            <tr>
                                <styles.att2><strong>Cost per Bike ($)</strong></styles.att2>
                                <styles.td>{profitMargin.cost_per_bike_dollars || "-"}</styles.td>
                            </tr>
                            <tr>
                                <styles.att2><strong>Profit Margin per Bike ($)</strong></styles.att2>
                                <styles.td>{profitMargin.profit_margin_per_bike_dollars || "-"}</styles.td>
                            </tr>
                            <tr>
                                <styles.att2><strong>Price per Bike ($)</strong></styles.att2>
                                <styles.td>{profitMargin.price_per_bike_dollars || "-"}</styles.td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    );
};

export default Submission;
